import { ReactElement } from "react";
import { Center, Spinner, SpinnerProps } from "@chakra-ui/react";

const LoadingSpinner = (props: SpinnerProps): ReactElement => (
  <Center flex={1} minH="400px">
    <Spinner {...props} />
  </Center>
);

export default LoadingSpinner;
